import ActionTypes from '../constants/actionTypes';

export default product => {
  return {
    type: ActionTypes.UPDATE[product],
    payload: { values: [] }
  };
};



// WEBPACK FOOTER //
// ./src/actions/clear_products.js